/**
 * UserIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const UserIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M8.38 8.88c0-2 1.62-3.624 3.62-3.63a3.64 3.64 0 0 1 3.63 3.63c-.003.617-.06 1.233-.17 1.84A3.58 3.58 0 0 1 12 14a3.58 3.58 0 0 1-3.46-3.28 10.5 10.5 0 0 1-.16-1.84M12 12c.91 0 1.36-.82 1.49-1.6q.134-.754.14-1.52a1.63 1.63 0 1 0-3.25 0 8.7 8.7 0 0 0 .13 1.52c.13.78.58 1.6 1.49 1.6"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M1 12C1 5.925 5.925 1 12 1a11 11 0 0 1 11 11c0 6.075-4.925 11-11 11S1 18.075 1 12m11 5c-2.75 0-4.73 1.27-5 2.49h.06a8.93 8.93 0 0 0 9.94 0c-.27-1.22-2.25-2.49-5-2.49m0-2c3.07 0 5.62 1.28 6.55 3.12h.03a9 9 0 1 0-13.16 0C6.38 16.28 8.93 15 12 15"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const UserIcon = makeIcon('UserIcon', UserIconSvg)
